/**
 * Runtime APIs the app uses without polyfilling. A browser missing one is considered below our support
 */
const requiredFeatures: Record<string, () => boolean> = {
  'Array.prototype.at': () => typeof Array.prototype.at === 'function',
  'crypto.randomUUID': () => typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function',
}

export function getMissingBrowserFeatures(): string[] {
  return Object.entries(requiredFeatures)
    .filter(([, isSupported]) => !isSupported())
    .map(([name]) => name)
}
